
import { format } from "date-fns";
import { mapGetters } from "vuex";
import { PAYMENT_STATUS_CODES, PAYMENT_STATUSES } from "@/config";
import UiButton from "~/components/UI/UiButton.vue";
export default {
  components: { UiButton },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
    showPaymentStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      orderDiscountType: {
        percent: 1,
        fixed: 2,
      },
      PAYMENT_STATUSES,
      PAYMENT_STATUS_CODES,
    };
  },
  computed: {
    ...mapGetters({
      getSystemDateFormat: "general/getSystemDateFormat",
      discountItems: "cart/getDiscountItems",
      giftCardItems: "cart/getGiftCardItems",
      discountValue: "cart/getDiscountValue",
      giftCardValue: "cart/getGiftCardValue",
    }),
    paymentMethodText() {
      return ["Apple Pay", "Google Pay", "Bank transfer"].includes(
        this.order.payment_method_name
      )
        ? this.order.payment_method_name
        : this.order.payment_method;
    },
    orderDate() {
      return format(
        new Date(this.order.customer_date),
        this.getSystemDateFormat
      );
    },
  },
};
